import { render, staticRenderFns } from "./ConfirmForms.vue?vue&type=template&id=3f78a61a"
import script from "./ConfirmForms.vue?vue&type=script&lang=js"
export * from "./ConfirmForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports